import {
  ATRIBUI_PAINEIS_USUARIO_INIT,
  PAINEL_USER_ERROR_MSG,
  PAINEL_USER_CLEAN_UP,
  ATRIBUI_PAINEIS_USUARIO_SUCCESS,
  DESATRIBUI_PAINEIS_USUARIO_INIT,
  DESATRIBUI_PAINEIS_USUARIO_SUCCESS
} from '../actionTypes';

export const atribuiPaineisUsuarioInit = (data) => ({
  type: ATRIBUI_PAINEIS_USUARIO_INIT,
  payload: data
});

export const atribuiPaineisUsuarioSuccess = ({ msg }) => ({
  type: ATRIBUI_PAINEIS_USUARIO_SUCCESS,
  payload: { msg }
});

export const desatribuiPaineisUsuarioInit = (data) => ({
  type: DESATRIBUI_PAINEIS_USUARIO_INIT,
  payload: data
});

export const desatribuiPaineisUsuarioSuccess = ({ msg }) => ({
  type: DESATRIBUI_PAINEIS_USUARIO_SUCCESS,
  payload: { msg }
});

export const painelUserErrorMsg = (msg) => ({
  type: PAINEL_USER_ERROR_MSG,
  payload: msg
});

export const painelClearStatus = (data) => ({
  type: PAINEL_USER_CLEAN_UP,
  payload: data
});
